import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar.tsx';
import { useTranslation } from 'react-i18next';
import type { AudiencesListFilters } from '../types.ts';

export const AudienceListTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<AudiencesListFilters>();

  return (
    <TopBar
      filters={criteria.filters as AudiencesListFilters}
      onChange={onFiltersChange}
      searchText={t('Search')}
      useFiltersV2
    />
  );
};
